var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 28.8867,
    r: 27.4141,
    fill: "#424242"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.7253 29C41.7253 29.667 41.1839 30.2083 40.5169 30.2083L16.9544 30.2083C16.2874 30.2083 15.7461 29.667 15.7461 29C15.7461 28.333 16.2874 27.7917 16.9544 27.7917L40.5169 27.7917C41.1864 27.7917 41.7253 28.333 41.7253 29Z",
    fill: "#888888"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3292 29C42.3292 29.3094 42.2108 29.6187 41.9764 29.8555L33.5181 38.3139C33.0468 38.7851 32.2807 38.7851 31.8095 38.3139C31.3382 37.8426 31.3382 37.0765 31.8095 36.6053L39.4123 29L31.8095 21.3972C31.3382 20.9259 31.3382 20.1599 31.8095 19.6886C32.2807 19.2174 33.0468 19.2174 33.5181 19.6886L41.9764 28.1469C42.2108 28.3814 42.3292 28.6907 42.3292 29V29Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.f4537baf24b4bbe63aafac2f154bc087.svg";
export { ForwardRef as ReactComponent };